import type { KeyboardEvent } from 'react';

const CANDIDATES = [
  'a[href]',
  'button:not([disabled])',
  'input:not([disabled]):not([type="hidden"])',
  'select:not([disabled])',
  'textarea:not([disabled])',
  '[tabindex]',
].join(', ');

function tabbablesIn(root: HTMLElement): HTMLElement[] {
  return [...root.querySelectorAll<HTMLElement>(CANDIDATES)].filter(
    (element) =>
      element.tabIndex >= 0 &&
      element.closest('[inert]') === null &&
      (typeof element.checkVisibility === 'function'
        ? element.checkVisibility({ checkVisibilityCSS: true })
        : element.getClientRects().length > 0),
  );
}

/**
 * Tab and Shift+Tab wrap inside a modal popup in the same keystroke, where Base UI's own trap moves
 * focus back a frame later. Called from the popup's `onKeyDown`.
 */
export function wrapTab(event: KeyboardEvent, root: HTMLElement): void {
  if (event.key !== 'Tab' || event.altKey || event.ctrlKey || event.metaKey) return;
  const tabbables = tabbablesIn(root);
  const first = tabbables[0];
  const last = tabbables.at(-1);
  if (first === undefined || last === undefined) return;
  const active = document.activeElement;
  if (event.shiftKey && (active === first || active === root)) {
    event.preventDefault();
    last.focus();
  } else if (!event.shiftKey && active === last) {
    event.preventDefault();
    first.focus();
  }
}
